import Dexie from 'dexie';

export class AppDB extends Dexie {
  products: any;
  customers: any;
  meta: any;

  constructor(dbName: string) {
    super(dbName);

    this.version(1).stores({
      products: '_id, updatedAt',
      customers: '_id, updatedAt',
      meta: 'key'
    });
  }
}

// 🔥 cache nhiều DB (tránh tạo lại nhiều lần)
const dbMap: Record<string, AppDB> = {};

let currentDB: AppDB | null = null;

// ✅ khởi tạo DB theo user/shop
export function initDB(userId: string) {
  const dbName = `POS_DB_${userId}`;

  if (!dbMap[dbName]) {
    dbMap[dbName] = new AppDB(dbName);
  }

  currentDB = dbMap[dbName];

  return currentDB;
}

// ✅ lấy DB hiện tại
export function getDB(): AppDB {
  if (!currentDB) {
    throw new Error('Database chưa được khởi tạo. Hãy gọi initDB() sau login.');
  }
  return currentDB;
}

// ✅ đóng DB (khi logout)
export function closeDB() {
  if (currentDB) {
    currentDB.close();
    currentDB = null;
  }
}

// ✅ (optional) xóa DB khỏi trình duyệt
export async function deleteDB(userId: string) {
  const dbName = `POS_DB_${userId}`;

  if (dbMap[dbName]) {
    dbMap[dbName].close();
    delete dbMap[dbName];
  }

  await Dexie.delete(dbName);
}